import { useState, useEffect } from 'react';
import { get } from '@helsenorge/framework-utils/hn-proxy-service';
import { error as logError } from '@helsenorge/framework-utils/logger';
export const getNextTitleLevel = (titleTag) => {
    switch (titleTag) {
        case 'h1':
            return 'h2';
        case 'h2':
            return 'h3';
        case 'h3':
            return 'h4';
        case 'h4':
            return 'h5';
        default:
            return 'h2';
    }
};
export const getSelvstendigVerktoyList = (toolIdList) => toolIdList.map(id => get('verktoynetcore', `api/v1/SelvstendigVerktoy/${id}`));
export const useToolData = (toolIdList) => {
    const [toolData, setToolData] = useState();
    useEffect(() => {
        const getToolData = async () => {
            const requests = getSelvstendigVerktoyList(toolIdList);
            try {
                const toolDataResponseList = await Promise.allSettled(requests);
                const filteredResponseList = toolDataResponseList
                    .filter((x) => x.status === 'fulfilled' && x.value !== null)
                    .map(x => x.value.Selvstendigverktoy);
                setToolData(filteredResponseList);
            }
            catch (e) {
                logError('Feil ved henting av verktøydata', e);
            }
        };
        getToolData();
    }, [toolIdList]);
    return toolData;
};
